import script from "./RecuperarContrasena.vue?vue&type=script&setup=true&lang=js"
export * from "./RecuperarContrasena.vue?vue&type=script&setup=true&lang=js"

import "./RecuperarContrasena.vue?vue&type=style&index=0&id=3fb8764d&lang=scss&scoped=true"

import exportComponent from "C:\\AgentesAzure\\SVRAPQAHIR01\\vsts-agent-win-x64-4.261.0\\_work\\18\\s\\hircasa-srp-webapp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3fb8764d"]])

export default __exports__